import { createSelector } from 'reselect'

export const getModalVisibility = currentID =>
  createSelector(
    state => state.modal,
    ({ isVisible, id }) => isVisible && id === currentID
  )
